import {
  Link,
  Toast,
  Toaster,
  ToastIntent,
  ToastTitle,
  ToastTrigger,
  useId,
  useToastController,
} from '@fluentui/react-components';
import parse from 'html-react-parser';
import { NotificationContext } from './Context';
import React from 'react';

export function NotificationProvider({ children }: { children: React.ReactNode }) {
  const toasterId = useId('toaster');
  const { dispatchToast } = useToastController(toasterId);

  const dispatchNotification = React.useCallback(
    (message: string, type: ToastIntent, timeout?: number) => {
      const defaultToastTimeout = type === 'error' ? -1 : 5000; // Error toasts stay until dismissed, others disappear after 5 seconds
      dispatchToast(
        <Toast>
          <ToastTitle
            action={
              <ToastTrigger>
                <Link>{'x'}</Link>
              </ToastTrigger>
            }
          >
            {parse(message)}
          </ToastTitle>
        </Toast>,
        {
          position: 'top',
          intent: type,
          timeout: timeout || defaultToastTimeout,
        }
      );
    },
    [dispatchToast]
  );

  return (
    <NotificationContext.Provider value={dispatchNotification}>
      {children}
      <Toaster toasterId={toasterId} />
    </NotificationContext.Provider>
  );
}
